<script setup lang="ts">
import { inject, ref, Ref } from 'vue';
import { getCurrentLocale } from '@/i18n';
import { formatDate } from '@/utils/dateUtils';
import Button from 'primevue/button';
import DataTable from 'primevue/datatable';
import TableColumn from 'primevue/column';

const dialogRef = inject('dialogRef') as Ref;
const paymentHistory = dialogRef?.value?.options?.data?.history;
const onClose = dialogRef?.value?.options?.emits?.onClose;

const currentLanguage = getCurrentLocale();
const rowsPerPageOptions = ref([10, 25, 50, 100, 200, 400, 500]);
</script>

<template>
  <div>
    <DataTable :value="paymentHistory" paginator :rows="rowsPerPageOptions[0]" scrollable tableStyle="min-width: 50rem">
      <template #empty> {{ $t('payment.no_payment_found') }} </template>
      <TableColumn class="capitalize" field="paymentDate" :header="$t('common.date')">
        <template #body="{ data }">
          {{ formatDate(data?.paymentDate, 'dd-LLL-yyyy', false, currentLanguage) }}
        </template>
      </TableColumn>
      <TableColumn class="capitalize" field="authNumber" :header="$t('payment.labels.authorization')"></TableColumn>
      <TableColumn class="capitalize" field="paymentType" :header="$t('payment.labels.type')"></TableColumn>
      <TableColumn class="capitalize" field="amountPaid" :header="$t('payment.labels.amount')"></TableColumn>
    </DataTable>
    <div class="text-center mt-2">
      <Button id="close-btn" :label="$t('common.buttons.ok')" @click="onClose()"></Button>
    </div>
  </div>
</template>
